import { gql } from 'graphql-request';
import { graphQLClient, getOrgId } from '@devd-client/api';
import type {
  TeamDtoWithHierarchyResponse,
  TeamComparisonDataResponse,
  GoalStatusSummaryDataResponse,
} from '../types/team-table.types';

export const getTeamsTableGraphql = async (
  currentPage: number,
  teamId: string,
  teams: string[]
): Promise<TeamDtoWithHierarchyResponse> =>
  await graphQLClient.request(
    gql`
      query GetTeamDtoWithHierarchy(
        $filter: Filter!
        $teams: [String]!
        $pageNumber: Int!
        $pageSize: Int!
      ) {
        TeamDtoWithHierarchy(
          filter: $filter
          pageNumber: $pageNumber
          teams: $teams
          pageSize: $pageSize
        ) {
          teamDtoList {
            name
            description
            memberCount
            parentTeam
            workingHours
            dailyDigest
            managers
            workingDays
            repoList
            subTeams {
              name
              description
              memberCount
              parentTeam
              workingHours
              dailyDigest
              managers
              workingDays
              repoList
              subTeams {
                name
                description
                memberCount
                parentTeam
                workingHours
                dailyDigest
                managers
                workingDays
                repoList
                subTeams {
                  name
                  description
                  memberCount
                  parentTeam
                  workingHours
                  dailyDigest
                  managers
                  workingDays
                  repoList
                  subTeams {
                    name
                    description
                    memberCount
                    parentTeam
                    workingHours
                    dailyDigest
                    managers
                    workingDays
                    repoList
                    teamMetaData {
                      members
                      managers
                      subTeams
                    }
                  }
                  teamMetaData {
                    members
                    managers
                    subTeams
                  }
                }
                teamMetaData {
                  members
                  managers
                  subTeams
                }
              }
              teamMetaData {
                members
                managers
                subTeams
              }
            }
            teamMetaData {
              members
              managers
              subTeams
            }
          }
          totalPages
          currentPage
          totalCount
        }
      }
    `,
    {
      filter: {
        orgId: `${getOrgId()}`,
        teamId: teamId,
      },
      teams,
      pageNumber: currentPage,
      pageSize: 10,
    }
  );
export const getTeamComparisonData = async (
  startDate: string,
  endDate: string,
  sprintId: string,
  teamId: string,
  teams: string[],
  metric: string,
  isPerMemberMetric: boolean,
  orderBy: string,
  pageNumber: number
): Promise<TeamComparisonDataResponse> =>
  await graphQLClient.request(
    gql`
      query GetTeamComparisonData(
        $filter: Filter!
        $metric: String!
        $teams: [String]!
        $orderBy: String!
        $pageNumber: Int!
        $pageSize: Int!
      ) {
        TeamComparisonData(
          filter: $filter
          metric: $metric
          teams: $teams
          pageNumber: $pageNumber
          pageSize: $pageSize
          orderBy: $orderBy
        ) {
          metricName
          rows {
            team
            isError
            metricRowDataList {
              metric
              count
              unit
              improved
              percentage
              color
              totalCount
              data
            }
          }
          totalPages
          currentPage
          totalCount
        }
      }
    `,
    {
      filter: {
        orgId: `${getOrgId()}`,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        startDate,
        endDate,
        sprintId,
        teamId,
        isPerMemberMetric,
      },
      metric,
      orderBy,
      teams,
      pageNumber,
      pageSize: 10,
    }
  );

export const getGoalStatusSummaryData = async (
  goalScope: string,
  associatedIds: string[]
): Promise<GoalStatusSummaryDataResponse> =>
  await graphQLClient.request(
    gql`
      query GetGoalStatusSummaryData(
        $orgId: String!
        $goalScope: String!
        $associatedIds: [String]!
      ) {
        GoalStatusSummaryData(
          orgId: $orgId
          goalScope: $goalScope
          associatedIds: $associatedIds
        ) {
          name
          goalStatusData {
            totalCount
            atRiskCount
            behindCount
            onTrackCount
          }
          keyResultStatusData {
            totalCount
            atRiskCount
            behindCount
            onTrackCount
          }
        }
      }
    `,
    {
      orgId: getOrgId(),
      goalScope,
      associatedIds,
    }
  );
